import { countries, type Country } from '@invo.space/shared'

export type { Country }

export const useCountries = (): readonly Country[] => countries
